    <div class="modal-popup">
        <div *ngIf="progress == null" class="spinner-grow text-dark me-2" role="status">
        </div>
        <p *ngIf="message" class="mt-3 text-center">{{ message }}</p>
        <div *ngIf="progress != null" class="progress w-75">
            <div class="progress-bar" role="progressbar" [style.width.%]="progress">{{ progress }}%</div>
        </div>
    </div>
